enum routes {
  ROOT = '/',
  REFIN = '/refinanciamento',
  REFIN_v2 = '/refinanciamento-novo',

  SEM_EMPRESTIMO_V1 = '/refinanciamento/sem-emprestimo',
  CONFIRMAR_CONTATO_V1 = '/refinanciamento/confirmar-contato',
  DADOS_RECEBIDOS_V1 = '/refinanciamento/dados-recebidos',
  CONTRATOS_V1 = '/refinanciamento/contratos',
  RESULTADO_V1 = '/refinanciamento/resultado',
  PARCELAMENTO_V1 = '/refinanciamento/parcelamento',
  NAO_LIBERADO_V1 = '/refinanciamento/nao-liberado',
  AUTORIZACAO_V1 = '/refinanciamento/autorizacao',
  SIMULACAO_V1 = '/refinanciamento/simulacao',
  ONBOARDING_CONTRATO_V1 = '/refinanciamento/onboarding-contrato',
  CONFERIR_REFINANCIAMENTO_V1 = '/refinanciamento/conferir-refinanciamento',
  LISTA_DOCUMENTOS_V1 = '/refinanciamento/lista-documentos',
  VISUALIZAR_DOCUMENTO_V1 = '/refinanciamento/visualizar-documento',

  VERIFICACAO = '/refinanciamento-novo/verificacao',
  CONTRATOS = '/refinanciamento-novo/contratos',
  AUTORIZACAO_CTPS = '/refinanciamento-novo/autorizacao-ctps',
  AUTORIZACAO_INSS = '/refinanciamento-novo/autorizacao-inss',
  OFERTA_SEGURO = '/refinanciamento-novo/oferta-seguro',
  RESULTADO_SIMULACAO = '/refinanciamento-novo/resultado-simulacao',
  CARREGAMENTO_SIMULACAO = '/refinanciamento-novo/carregando-simulacao',
  CARREGAMENTO_FORMALIZACAO = '/refinanciamento-novo/carregando-formalizacao',
  STATUS_DOCUMENTO = '/refinanciamento-novo/status-documento',
  FOTO_DOCUMENTO = '/refinanciamento-novo/foto-documento',
  MODO_ENVIO_CONTRA_CHEQUE = '/refinanciamento-novo/modo-envio-contracheque',
  FOTO_CONTRA_CHEQUE = '/refinanciamento-novo/foto-contracheque',
  MODO_ENVIO = '/refinanciamento-novo/modo-envio',
  REVISAO = '/refinanciamento-novo/revisao',
  TERMOS_CONTRATACAO = '/refinanciamento-novo/termos',
  TERMO_VISUALIZACAO = '/refinanciamento-novo/termo-visualizacao',
  SUCESSO = '/refinanciamento-novo/sucesso',
  NAO_LIBERADO = '/refinanciamento-novo/nao-liberado',
  DADOS_BANCARIOS = '/refinanciamento-novo/dados-bancarios',
  ENDERECO = '/refinanciamento-novo/endereco',
  INFORMACOES_PESSOAIS = '/refinanciamento-novo/informacoes-pessoais',
  INDISPONIVEL = '/refinanciamento-novo/indisponivel',
  SERVICO_INDISPONIVEL = '/refinanciamento-novo/servico-indisponivel',
  SEM_EMPRESTIMO = '/refinanciamento-novo/sem-emprestimo',
  SEM_PARCELA = '/refinanciamento-novo/sem-parcela',
  DESQUALIFICACAO = '/refinanciamento-novo/desqualificacao',
  ERRO = '/refinanciamento-novo/erro',
  INSS_BLOQUEADO = '/refinanciamento-novo/inss-bloqueado',
  BENEFICIO_BLOQUEADO = '/refinanciamento-novo/beneficio-bloqueado',
  INSS_INDISPONIVEL = '/refinanciamento-novo/inss-indisponivel',
  DOCUMENTO_IDENTIFICACAO = '/refinanciamento-novo/documento-identificacao',
  FAQ = '/refinanciamento-novo/faq',
  TUTORIAL = '/refinanciamento-novo/tutorial',
  BIOMETRIA_LIVENESS = '/refinanciamento-novo/liveness',
}
export default routes
